import { Grid } from '@material-ui/core'
import React from 'react'
import { useHistory } from 'react-router'
import { loadingAndText } from '../shared/constants'
import CustomButton from './CustomButton'

export default function ActionButton({
  handleSubmit,
  text1 = 'Cancel',
  text = 'Submit',
  redirect,
  disableButton,
  loading,
  state,
  setState
}) {
  const history = useHistory()
  return (
    <Grid container>
      <Grid item lg={4} style={{ margin: '100px 20px 20px 0px' }}>
        <br />
        <CustomButton
          handleSubmit={
            // state
            //   ? ()=>{setState({})}
            //   :
             () => {
                  history.push(redirect)
                  localStorage.removeItem('leadProducts')
                }
          }
          text={text1}
        />
      </Grid>
      <Grid item lg={4} style={{ margin: '100px 20px 20px 0px' }}>
        <br />
        <CustomButton
          text={loadingAndText(loading, text)}
          handleSubmit={handleSubmit}
          disabled={loading || disableButton}
        />
      </Grid>
    </Grid>
  )
}
